import api from './index.js'

const proxyHandler = {
    get(target, prop) {
        if (prop == 'isMocked') {
            return true
        }
        if (target[prop] == null) {
            return null
        }
        var type = typeof target[prop]
        if (type === 'object') {
            return new Proxy(target[prop], proxyHandler)
        } else if (type === 'function') {
            return async () => {
                return await Promise.resolve({})
            }
        } else {
            return Promise.resolve({})
        }
    }
}

export default new Proxy(api, proxyHandler)
